import React from 'react'
import LeftBar from './LeftBar'
// import CentreBar from './CentreBar'
import RightSideBar from './RightSideBar'
import newicon from './img/newicon.gif'
import { useNavigate, Link } from 'react-router-dom'
import Header from './Header'
import Marque from './Marque'
import Footer from '../Registration/Footer'
// import newicon from './img/newicon.gif'
function Eligibility() {
    const navigate = useNavigate()
    return (
        <div>
            <Header />
            <Marque />
            <section className="contentsection mt-2" id="skipcontent">
                <div className="container-fluid">
                    <div className="" style={{ width: '100%', margin: 'auto' }}>

                        {/* <!-- LEFT SIDEBAR START HERE --> */}
                        {/* <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                            <LeftBar />
                        </div> */}
                        {/* </div> <!-- LEFT SIDEBAR END HERE --> */}


                        <>
                            <div className="col-lg-8 col-md-10 col-sm-12 col-xs-12" style={{ margin: 'auto' }}>
                                <div className="mb-4">
                                    <div className="mb-4 pagecontentpara">
                                        <h5 className="pageheading" style={{ fontSize: '1.2rem', fontWeight: 'bold', color: 'black', textAlign: 'center' }}>Eligibility For AICEE - 2026</h5>
                                        <div className="list-group " >
                                            <div>
                                                <a
                                                    href='https://docs.aicee.in/uploads/eligibility-criteria-for-engineering.pdf'
                                                    target="_blank"
                                                    className="list-group-item list-group-item-action flex items-center"
                                                >
                                                    <span className='flex'><span className='text-black font-bold'><i class="fas fa-file-pdf text-red-600 text-xl"></i>.&nbsp;Eligibility for AICEE 2026 Engineering (BE / B-Tech) Program </span>
                                                        <span><sup>
                                                            <img src={newicon} />
                                                        </sup></span></span>
                                                </a>
                                            </div>
                                            <a
                                                href='https://docs.aicee.in/uploads/eligibility-criteria-b-a-b-com-b-sc.pdf'
                                                target="_blank"
                                                className="list-group-item list-group-item-action"
                                            >
                                                <span className='flex'><span className='text-black font-bold'><i class="fas fa-file-pdf text-red-600 text-xl"></i>.&nbsp; Eligibility Criteria B.A B.Com B.Sc </span>
                                                    <span><sup>
                                                        <img src={newicon} />
                                                    </sup></span></span>
                                            </a>
                                            <a
                                                href='https://docs.aicee.in/uploads/eligibility-criteria-of-bachelor-of-physiotherapy-students.pdf'
                                                target="_blank"
                                                className="list-group-item list-group-item-action"
                                            >
                                                <span className='flex'><span className='text-black font-bold'><i class="fas fa-file-pdf text-red-600 text-xl"></i>.&nbsp; Eligibility Criteria BPT ( Bachelor of physiotherapy ) Students </span>
                                                    <span><sup>
                                                        <img src={newicon} />
                                                    </sup></span></span>
                                            </a>
                                            <a
                                                href='https://docs.aicee.in/uploads/eligibility-criteria-bio-technology----pcb---students.pdf'
                                                target="_blank"
                                                className="list-group-item list-group-item-action"
                                            >
                                                <span className='flex'><span className='text-black font-bold'><i class="fas fa-file-pdf text-red-600 text-xl"></i>.&nbsp; Eligibility Criteria Bio-Technology  ( PCB ) Students </span>
                                                    <span><sup>
                                                        <img src={newicon} />
                                                    </sup></span></span>
                                            </a>
                                            <a
                                                href='https://docs.aicee.in/uploads/eligibility-criteria-bsc--nursing.pdf'
                                                target="_blank"
                                                className="list-group-item list-group-item-action"
                                            >
                                                <span className='flex'><span className='text-black font-bold'><i class="fas fa-file-pdf text-red-600 text-xl"></i>.&nbsp; Eligibility Criteria Bsc. Nursing </span>
                                                    <span><sup>
                                                        <img src={newicon} />
                                                    </sup></span></span>
                                            </a>
                                            <a
                                                href='https://docs.aicee.in/uploads/eligibility-criteria-for--b--pharmacy-pcm-students.pdf'
                                                target="_blank"
                                                className="list-group-item list-group-item-action"
                                            >
                                                <span className='flex'><span className='text-black font-bold'><i class="fas fa-file-pdf text-red-600 text-xl"></i>.&nbsp; Eligibility Criteria for  B. pharmacy ( PCM ) students </span>
                                                    <span><sup>
                                                        <img src={newicon} />
                                                    </sup></span></span>
                                            </a>
                                            <a
                                                href='https://docs.aicee.in/uploads/eligibility-criteria-for--b--pharmacy-pcb-students.pdf'
                                                target="_blank"
                                                className="list-group-item list-group-item-action"
                                            >
                                                <span className='flex'><span className='text-black font-bold'><i class="fas fa-file-pdf text-red-600 text-xl"></i>.&nbsp; Eligibility Criteria for  B. Pharmacy (PCB )Students </span>
                                                    <span><sup>
                                                        <img src={newicon} />
                                                    </sup></span></span>
                                            </a>
                                            <a
                                                href='https://docs.aicee.in/uploads/eligibility-criteria-for-aeronautical-aerospace-engineering.pdf'
                                                target="_blank"
                                                className="list-group-item list-group-item-action"
                                            >
                                                <span className='flex'><span className='text-black font-bold'><i class="fas fa-file-pdf text-red-600 text-xl"></i>.&nbsp; Eligibility Criteria for Aeronautical Aerospace engineering </span>
                                                    <span><sup>
                                                        <img src={newicon} />
                                                    </sup></span></span>
                                            </a>
                                            <a
                                                href='https://docs.aicee.in/uploads/eligibility-criteria-for-agriculture---pcm---students.pdf'
                                                target="_blank"
                                                className="list-group-item list-group-item-action"
                                            >
                                                <span className='flex'><span className='text-black font-bold'><i class="fas fa-file-pdf text-red-600 text-xl"></i>.&nbsp; Eligibility Criteria for Agriculture ( PCM ) students </span>
                                                    <span><sup>
                                                        <img src={newicon} />
                                                    </sup></span></span>
                                            </a>
                                            <a
                                                href='https://docs.aicee.in/uploads/eligibility-criteria-for-b--design.pdf'
                                                target="_blank"
                                                className="list-group-item list-group-item-action"
                                            >
                                                <span className='flex'><span className='text-black font-bold'><i class="fas fa-file-pdf text-red-600 text-xl"></i>.&nbsp; Eligibility Criteria for B. design </span>
                                                    <span><sup>
                                                        <img src={newicon} />
                                                    </sup></span></span>
                                            </a>
                                            <a
                                                href='https://docs.aicee.in/uploads/eligibility-criteria-for-bba-bca.pdf'
                                                target="_blank"
                                                className="list-group-item list-group-item-action"
                                            >
                                                <span className='flex'><span className='text-black font-bold'><i class="fas fa-file-pdf text-red-600 text-xl"></i>.&nbsp; Eligibility Criteria for BBA BCA </span>
                                                    <span><sup>
                                                        <img src={newicon} />
                                                    </sup></span></span>
                                            </a>
                                            <a
                                                href='https://docs.aicee.in/uploads/eligibility-criteria-for-bio-technology--pcm-students--.pdf'
                                                target="_blank"
                                                className="list-group-item list-group-item-action"
                                            >
                                                <span className='flex'><span className='text-black font-bold'><i class="fas fa-file-pdf text-red-600 text-xl"></i>.&nbsp; Eligibility Criteria for Bio-Technology (PCM Students ) </span>
                                                    <span><sup>
                                                        <img src={newicon} />
                                                    </sup></span></span>
                                            </a>
                                            <a
                                                href='https://docs.aicee.in/uploads/eligibility-criteria-for-llb.pdf'
                                                target="_blank"
                                                className="list-group-item list-group-item-action"
                                            >
                                                <span className='flex'><span className='text-black font-bold'><i class="fas fa-file-pdf text-red-600 text-xl"></i>.&nbsp; Eligibility Criteria for LLB programs </span>
                                                    <span><sup>
                                                        <img src={newicon} />
                                                    </sup></span></span>
                                            </a>
                                            <a
                                                href='https://docs.aicee.in/uploads/eligibility-criteria-for-mass-communication.pdf'
                                                target="_blank"
                                                className="list-group-item list-group-item-action"
                                            >
                                                <span className='flex'><span className='text-black font-bold'><i class="fas fa-file-pdf text-red-600 text-xl"></i>.&nbsp; Eligibility Criteria for Mass Communication </span>
                                                    <span><sup>
                                                        <img src={newicon} />
                                                    </sup></span></span>
                                            </a>
                                          
                                            <a
                                                href='https://docs.aicee.in/uploads/eligibility-criteria-for-mba.pdf'
                                                target="_blank"
                                                className="flex list-group-item"
                                            >
                                                <span className='flex'><span className='text-black font-bold'><i class="fas fa-file-pdf text-red-600 text-xl"></i>&nbsp;Eligibility for AICEE 2026 MBA / PGDM Program</span>
                                                    <span><sup>
                                                        <img src={newicon} />
                                                    </sup></span></span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* INTRO SECTION END HERE */}
                        </>



                        {/* <!-- RIGHT SIDEBAR START HERE --> */}
                        {/* <div className="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                            <RightSideBar />
                        </div> */}
                        {/* <!-- RIGHT SIDEBAR END HERE --> */}

                    </div>
                </div>
            </section>

            {/* <Footer /> */}
        </div>
    )
}

export default Eligibility

